import { useNavigate } from 'react-router';

export default function ErrorPage() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleBackToHome = () => {
    navigate('/dashboard');
  };

  return (
    <section className="w-full min-h-screen flex flex-col items-center justify-center bg-white text-gray-800 dark:bg-gray-900 dark:text-gray-100 px-4 text-center">
      <figure className="max-w-md mb-6">
        <img
          src="https://cdn.dribbble.com/users/722246/screenshots/3066818/404-page.gif"
          alt="404 page"
          className="rounded-lg shadow-md"
        />
      </figure>

      <div className="mb-6">
        <p className="text-xl font-medium mb-2">
          The page you were looking for could not be found
        </p>
        <p className="text-gray-600 dark:text-gray-400">
          You can go back or return to the homepage
        </p>
      </div>

      <div className="space-x-4">
        <button onClick={handleBack} className="btn-secondary">
          Go Back
        </button>
        <button onClick={handleBackToHome} className="btn-primary">
          Go to Homepage
        </button>
      </div>
    </section>
  );
}
